import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../../components/ui/Header';
import PersonalInfoSection from './components/PersonalinfoSection';
import InterviewPreferencesSection from './components/InterviewPreferencesSection';
import NotificationSettingsSection from './components/NotificationSettingsSection';
import PerformanceAnalyticsSection from './components/PerformanceAnalyticsSection';
import SecuritySection from './components/SecuritySection';
import SubscriptionSection from './components/SubscriptionSection';
import DataExportSection from './components/DataExportSection';

const UserProfileSettings = () => {
  const [activeSection, setActiveSection] = useState('personal');

  const sections = [
    { id: 'personal', label: 'Personal Info', component: PersonalInfoSection },
    { id: 'preferences', label: 'Interview Preferences', component: InterviewPreferencesSection },
    { id: 'notifications', label: 'Notifications', component: NotificationSettingsSection },
    { id: 'analytics', label: 'Performance', component: PerformanceAnalyticsSection },
    { id: 'security', label: 'Security', component: SecuritySection },
    { id: 'subscription', label: 'Subscription', component: SubscriptionSection },
    { id: 'export', label: 'Data Export', component: DataExportSection }
  ];

  const ActiveComponent = sections?.find(s => s?.id === activeSection)?.component;

  return (
    <>
      <Helmet>
        <title>Profile Settings - InterviewAce</title>
        <meta name="description" content="Manage your InterviewAce account settings, preferences, and subscription" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-[60px]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="mb-8">
              <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
                Account Settings
              </h1>
              <p className="text-muted-foreground">
                Manage your profile, preferences, and account security
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6">
              <aside className="lg:w-64 flex-shrink-0">
                <nav className="bg-card border border-border rounded-lg shadow-elevation-1 overflow-hidden sticky top-20">
                  <div className="p-2">
                    {sections?.map((section) => (
                      <button
                        key={section?.id}
                        onClick={() => setActiveSection(section?.id)}
                        className={`
                          w-full text-left px-4 py-3 rounded-md text-sm font-medium transition-all duration-150 ease-out
                          ${activeSection === section?.id
                            ? 'bg-primary text-primary-foreground shadow-elevation-1'
                            : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                          }
                        `}
                      >
                        {section?.label}
                      </button>
                    ))}
                  </div>
                </nav>
              </aside>

              <div className="flex-1 min-w-0">
                {ActiveComponent && <ActiveComponent />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default UserProfileSettings;